import { inject } from '@angular/core';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CanActivateFn, UrlTree } from '@angular/router';
import { AuthService } from 'auth';

export const loggedInGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const authService = inject(AuthService);

  return from(authService.isAuthenticated()).pipe(map((isAuthenticated: boolean) => !isAuthenticated));
};
